<div class="preset-management">
	<div class="modal-header border-0">
		<div class="container-fluid px-0">
			<ul ngbNav class="nav-tabs">
				<li ngbNavItem role="presentation">
					<h4 class="mb-0">
						<i class="bi bi-palette-fill me-2 text-primary"></i
						>Tyyliasetusten hallinta
					</h4>
				</li>

				<!-- Plugin type filter dropdown -->
				<li
					ngbDropdown
					class="nav-item ms-auto d-flex align-items-center"
					role="presentation"
				>
					<button
						type="button"
						class="btn btn-sm fs-5"
						ngbDropdownToggle
					>
						<i class="bi bi-funnel me-1"></i>
						<span
							class="badge bg-primary"
							*ngIf="filterPluginType !== null"
						>
							1
						</span>
					</button>
					<div ngbDropdownMenu>
						<button
							ngbDropdownItem
							(click)="filterPluginType = null"
							[class.active]="filterPluginType === null"
						>
							<i
								*ngIf="filterPluginType === null"
								class="bi bi-check me-2"
							></i>
							<i
								*ngIf="filterPluginType !== null"
								class="bi bi-square me-2"
								style="visibility: hidden"
							></i>
							Kaikki pelit
						</button>
						<button
							ngbDropdownItem
							*ngFor="let pt of availablePluginTypes"
							(click)="filterPluginType = pt.type"
							[class.active]="filterPluginType === pt.type"
						>
							<i
								*ngIf="filterPluginType === pt.type"
								class="bi bi-check me-2"
							></i>
							<i
								*ngIf="filterPluginType !== pt.type"
								class="bi bi-square me-2"
								style="visibility: hidden"
							></i>
							{{ pt.title }}
						</button>
					</div>
				</li>

				<!-- Search input -->
				<li ngbNavItem>
					<form class="form-inline">
						<input
							class="form-control"
							type="search"
							placeholder="Hae nimellä tai kuvauksella..."
							aria-label="Hae"
							[(ngModel)]="filterText"
							name="filterText"
						/>
					</form>
				</li>
			</ul>
		</div>
		<button
			type="button"
			class="btn-close"
			aria-label="Close"
			(click)="close()"
		></button>
	</div>

	<div class="modal-body">
		<!-- Clear filters button -->
		<!-- <div class="mb-2" *ngIf="hasActiveFilters()">
			<button
				type="button"
				class="btn btn-link btn-sm p-0"
				(click)="clearFilters()"
			>
				<i class="bi bi-x-circle me-1"></i>
				Tyhjennä suodattimet
			</button>
		</div> -->

		<!-- Presets list -->
		<div class="presets-list">
			<div
				*ngIf="getFilteredPresets().length === 0"
				class="text-center text-muted py-4"
			>
				<i class="bi bi-inbox" style="font-size: 2rem"></i>
				<p class="mt-2">
					{{
						hasActiveFilters()
							? "Ei esiasetuksia suodattimilla"
							: "Ei tallennettuja esiasetuksia"
					}}
				</p>
			</div>

			<div
				class="table-responsive"
				*ngIf="getFilteredPresets().length > 0"
			>
				<table class="table table-striped">
					<thead>
						<tr>
							<th
								scope="col"
								class="sortable-header"
								(click)="sortPresets('name')"
							>
								Nimi
								<i
									class="ms-1"
									[ngClass]="getSortIcon('name')"
								></i>
							</th>
							<th scope="col">Kuvaus</th>
							<th
								scope="col"
								class="sortable-header"
								(click)="sortPresets('plugin')"
							>
								Peli
								<i
									class="ms-1"
									[ngClass]="getSortIcon('plugin')"
								></i>
							</th>
							<th
								scope="col"
								class="sortable-header"
								(click)="sortPresets('date')"
							>
								Muokattu
								<i
									class="ms-1"
									[ngClass]="getSortIcon('date')"
								></i>
							</th>
							<th scope="col" class="text-end"></th>
						</tr>
					</thead>
					<tbody>
						<tr
							*ngFor="
								let preset of getFilteredPresets();
								trackBy: trackByPresetId
							"
							[@fadeInImmediately]
						>
							<td>
								<strong>{{ preset.name }}</strong>
							</td>
							<td>
								<small class="text-muted">{{
									preset.description || "-"
								}}</small>
							</td>
							<td>
								<span class="badge bg-secondary">
									{{
										getPluginTypeName(
											preset.createdFromPlugin
										)
									}}
								</span>
							</td>
							<td>
								<small class="text-muted">{{
									formatDate(preset.modifiedAt)
								}}</small>
							</td>
							<td class="text-end">
								<div
									class="btn-group btn-group-sm"
									role="group"
								>
									<button
										type="button"
										class="btn btn-outline-primary"
										(click)="editPreset(preset)"
										title="Muokkaa"
									>
										<i class="bi bi-pencil"></i>
									</button>
									<button
										type="button"
										class="btn btn-outline-danger"
										(click)="
											confirmDeletePreset(
												preset,
												deletePresetModal
											)
										"
										title="Poista"
									>
										<i class="bi bi-trash"></i>
									</button>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>

	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="close()">
			Sulje
		</button>
	</div>
</div>

<!-- Delete confirmation modal -->
<ng-template #deletePresetModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">Vahvista poisto</h5>
		<button
			type="button"
			class="btn-close"
			aria-label="Close"
			(click)="modal.dismiss(); cancelDelete()"
		></button>
	</div>
	<div class="modal-body">
		<p>
			Haluatko varmasti poistaa esiasetuksen
			<strong>{{ presetToDelete?.name }}</strong
			>?
		</p>
		<p class="text-muted mb-0">Tätä toimintoa ei voi perua.</p>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn btn-secondary"
			(click)="modal.dismiss(); cancelDelete()"
		>
			Peruuta
		</button>
		<button
			type="button"
			class="btn btn-danger"
			(click)="modal.close(); deletePreset()"
		>
			Poista
		</button>
	</div>
</ng-template>
